// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__37S83","inputWrap":"CustomTip_inputWrap__2kHrP"};